import { useStore } from '../../store';
import { NEW_MESSAGE_WINDOW } from '../../store/slices/chatWindows';
import { AnnouncersView } from './AnnouncersView';
import { ConnectionStrip } from './ConnectionStrip';
import { ConversationBody } from './ConversationBody';
import { MembersView } from './MembersView';
import { NewMessage } from './NewMessage';

/**
 * What a chat surface shows under its header: New message, Members,
 * Announcers or the conversation. The floating window and the phone sheet
 * share it.
 */
export function WindowBody({
  id,
  touch = false,
  onGone,
}: {
  id: string;
  touch?: boolean;
  /** The conversation is gone (archived, membership lost). */
  onGone: () => void;
}) {
  const view = useStore(state => state.windowViews[id] ?? 'conversation');
  const replaceChatWindow = useStore(state => state.replaceChatWindow);
  const setChatWindowView = useStore(state => state.setChatWindowView);
  const back = () => setChatWindowView(id, 'conversation');

  if (id === NEW_MESSAGE_WINDOW)
    return (
      <>
        <ConnectionStrip />
        <NewMessage
          touch={touch}
          onOpenChannel={channelId =>
            replaceChatWindow(NEW_MESSAGE_WINDOW, channelId)
          }
        />
      </>
    );
  if (view === 'members')
    return (
      <>
        <ConnectionStrip />
        <MembersView channelId={id} touch={touch} onBack={back} />
      </>
    );
  if (view === 'announcers')
    return (
      <>
        <ConnectionStrip />
        <AnnouncersView channelId={id} touch={touch} onBack={back} />
      </>
    );
  // The body draws its own ConnectionStrip. Keyed by id so its local state
  // (archived-on-409, notice, lightbox) never carries over from another
  // conversation.
  return (
    <ConversationBody key={id} channelId={id} touch={touch} onGone={onGone} />
  );
}
